import { httpClient } from 'providers/clients/httpClient';
import qs from 'qs';
import {
  DeleteRelatedContentStyleResponse,
  GetRelatedContentStyleResponse,
  GetRelatedContentStylesResponse,
  PostRelatedContentStyleResponse,
  PutRelatedContentStyleResponse,
  RelatedContentStyle,
  TGetRelatedContentStylesParams,
} from 'utility/types/dataProvider';

// -----------------------------------------------
// ------- RELATED CONTENT STYLES PROVIDER -------
// -----------------------------------------------
export const relatedContentStylesProvider = {
  // Get all related content styles.
  getRelatedContentStyles: async ({
    params,
  }: TGetRelatedContentStylesParams): Promise<GetRelatedContentStylesResponse> => {
    try {
      let url = `/editorial/relatedcontentstyle/list/`;

      if (params) {
        url += `?${qs.stringify(params)}`;
      }

      const { data } = await httpClient({
        url: url,
        method: 'GET',
      });

      return data;
    } catch (error) {
      console.error('[getRelatedContentStyles] Error', error);
      throw error;
    }
  },

  // Get related content style by id.
  getRelatedContentStyle: async (id: string): Promise<GetRelatedContentStyleResponse> => {
    try {
      const { data } = await httpClient({
        url: `/editorial/relatedcontentstyle/${id}/`,
        method: 'GET',
      });

      return data;
    } catch (error) {
      console.error('[getRelatedContentStyle] Error', error);
      throw error;
    }
  },

  // Post related content style.
  postRelatedContentStyle: async (
    body: RelatedContentStyle,
  ): Promise<PostRelatedContentStyleResponse> => {
    try {
      const { data } = await httpClient({
        url: `/editorial/relatedcontentstyle/`,
        method: 'POST',
        data: JSON.stringify(body),
      });

      return data;
    } catch (error) {
      console.error('[postRelatedContentStyle] Error', error);
      throw error;
    }
  },

  // Put related content style.
  putRelatedContentStyle: async (
    id: string,
    body: RelatedContentStyle,
  ): Promise<PutRelatedContentStyleResponse> => {
    try {
      const { data } = await httpClient({
        url: `/editorial/relatedcontentstyle/${id}/`,
        method: 'PUT',
        data: JSON.stringify(body),
      });

      return data;
    } catch (error) {
      console.error('[putRelatedContentStyle] Error', error);
      throw error;
    }
  },

  // Delete related content style.
  deleteRelatedContentStyle: async (
    id: number,
  ): Promise<DeleteRelatedContentStyleResponse> => {
    try {
      const { data } = await httpClient({
        url: `/editorial/relatedcontentstyle/${id}/`,
        method: 'DELETE',
      });

      return data;
    } catch (error) {
      console.error('[deleteRelatedContentStyle] Error', error);
      throw error;
    }
  },
};
